import { Component, ElementRef, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import * as CryptoJS from 'crypto-js'
import { environment } from '../../environments/environment'
import { AppService } from '../app.service'
import { AlertService } from '../_services/index'
import { DataService } from '../data.service'
import { LoginService } from './login.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  currentUrl: any
  passwordType: any = 'password'
  model: any = {}
  btnDisable: boolean
  accessToken: any
  admin_type = ''
  expiresIn: any
  tokenType: any
  feature_access = []
  rememberMe: any = false
  encryptedData: any
  decryptedData: any
  password: any
  redirectUrl: any
  userTypeData: any
  contentInfo: any = {}
  appConstant = environment
  logo: any
  constructor(
    private router: Router,
    private dataService: DataService,
    private alertService: AlertService,
    private el: ElementRef,
    private loginService: LoginService,
    private appService: AppService
  ) {
    if (localStorage.getItem('adminInfo')) {
      this.router.navigate(['/dashboard'])
    }
  }

  ngOnInit(): any {
    if (window.location.href == this.appConstant.brandAdminBaseUrl) {
      this.router.navigate(['/brand-login'])
    } else if (window.location.href == this.appConstant.baseUrl) {
      this.router.navigate(['/'])
    }
    this.appService.getInformation().subscribe((data: any) => {
      this.contentInfo = JSON.stringify(data)
      localStorage.setItem('contentInfo', this.contentInfo)
      this.dataService.changeLocalData('update data')
      if (data.website_content.backend_logo.backend_logo) {
        this.logo = this.appConstant.contentImagePath + data.website_content.backend_logo.backend_logo
      }
    })
    this.userTypeData = this.router.url
    if (this.router.url === '/brand-login') {
      this.model.userType = 'brand'
      this.redirectUrl = '/brand-forgot-password'
    } else {
      this.model.userType = 'superuser'
      this.redirectUrl = '/forgot-password'
    }

    this.encryptedData = localStorage.getItem('rememberMe')
    if (this.encryptedData) {
      this.model = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )

      this.rememberMe = true
    }
    this.dataService.changeProfileService({ url: '/dashboard' })
  }
  errorHandler(event: any): void {
    event.target.src = environment.logoNoImage
  }
  changePasswordType(): void {
    if (this.passwordType === 'password') {
      this.passwordType = 'text'
    } else {
      this.passwordType = 'password'
    }
  }
  login(valid: any): void {
    if (valid) {
      if (this.router.url === '/brand-login') {
        this.model.userType = 'brand'
      } else {
        this.model.userType = 'superuser'
      }
      this.btnDisable = true
      this.loginService.login(this.model).subscribe(
        (data: any) => {
          this.accessToken = data.access_token
          this.expiresIn = data.expires_in
          this.tokenType = data.token_type
          this.password = this.model.password
          this.admin_type = data.admin_type
          this.feature_access = data.feature_access
          this.getUserInfo()
        },
        (err: any) => {
          this.btnDisable = false
          if (err.error.error) {
            this.alertService.error(err.error.error)
          }
        }
      )
    } else {
      this.scrollToFirstInvalidControl()
    }
  }
  private scrollToFirstInvalidControl(): void {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      'form .ng-invalid'
    )
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth',
    })
    setTimeout(() => {
      firstInvalidControl.focus()
    }, 1000)
  }
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset: any = 50
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset
  }

  getUserInfo(): void {
    const sendData: any = {
      accessToken: this.accessToken,
      expiresIn: this.expiresIn,
      tokenType: this.tokenType,
    }
    if (this.router.url === '/brand-login') {
      sendData.userType = 'brand'
    } else {
      sendData.userType = 'superuser'
    }
    this.loginService.getUserInfo(sendData).subscribe(
      (data: any) => {
        this.model = JSON.parse(JSON.stringify(data))
        this.model.userType = sendData.userType
        this.model.first_name = data.first_name
        this.model.last_name = data.last_name
        this.model.email = data.email
        this.model.image = data.image
        this.model.accessToken = this.accessToken
        this.model.expiresIn = this.expiresIn
        this.model.tokenType = this.tokenType
        this.model.password = this.password
        this.model.feature_access = this.feature_access
        this.model.admin_type = this.admin_type
        const setUserData: any = CryptoJS.AES.encrypt(
          JSON.stringify(this.model),
          environment.secretKey
        ).toString()

        localStorage.setItem('adminInfo', setUserData)
        this.btnDisable = false
        this.alertService.success('You are logged in successfully.')
        if (this.rememberMe === true) {
          const rememberMe: any = CryptoJS.AES.encrypt(
            JSON.stringify(this.model),
            environment.secretKey
          ).toString()
          this.encryptedData = localStorage.setItem('rememberMe', rememberMe)
        } else {
          localStorage.removeItem('rememberMe')
        }
        this.router.navigate(['/dashboard'])
      },
      (err: any) => {
        this.btnDisable = false
        if (err.status === 400 || err.status === 401) {
          if (err.error.errorMessage) {
          }
        }
      }
    )
  }
}
